import React, { useEffect, useState } from 'react'
import { ACTIONS } from '../redux/actions'
import { useDispatch, useSelector } from 'react-redux';


export default function DynamicTabs({ tabs = [], onTabChange }) {
  const dispatch = useDispatch();
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
  const [activeTab, setActiveTab] = useState(tabs?.data?.rows[0]?.id || '')
  const handleTabClick = (tabId) => {
    setActiveTab(tabId?.id)
    if (onTabChange) {
      onTabChange("semester_id", tabId)
    }
  }

  useEffect(() => {
    if (tabs?.data?.rows) {
      let payload = {
        ...selectedData,
        subject_id: '',
        "semester_id": tabs?.data?.rows[0]?.id,
        "semester_name": tabs?.data?.rows[0]?.semester
      }
      dispatch(ACTIONS.getSelectedData(payload))
    }
    setActiveTab(tabs?.data?.rows[0]?.id)

  }, [tabs?.data?.rows])

  return (
    <div className="w-full  mx-auto bg-[#F6F7F9]">
      <div className="flex justify-between border-b border-gray-200">
        {tabs?.data?.rows?.map((tab) => (
          <button
            key={tab?.id}
            className={`flex-1 py-4 px-4 text-sm md:text-base font-medium text-center focus:outline-none ${activeTab == tab?.id
              ? 'text-[#108EE3] border-b-2 border-[#108EE3]'
              : 'text-gray-500 hover:text-gray-700'
              }`}
            onClick={() => handleTabClick(tab)}
          >
            {tab?.semester}
          </button>
        ))}
      </div>
    </div>
  )
}